module.exports = __webpack_public_path__ + "static/media/erdbcreate.2354eb88.svg";